 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/EBB'
 import TLU from '@/components/TLU'
 import MM from '@/components/MM'
 import LOVE1 from '@/components/love1'
 import TITLEPAGE from '@/components/Titlepage'
 import DED from '@/components/ded'
 import EPIGRAPH from '@/components/epigraph'
 import A7815040816961 from '@/components/9781504081696-1'
 import A7815040816962 from '@/components/9781504081696-2'
 import A7815040816963 from '@/components/9781504081696-3'
 import A7815040816965 from '@/components/9781504081696-5'
 import A7815040816966 from '@/components/9781504081696-6'
 import A7815040816967 from '@/components/9781504081696-7'
 import A7815040816968 from '@/components/9781504081696-8'
 import A78150408169610 from '@/components/9781504081696-10'
 import A78150408169611 from '@/components/9781504081696-11'
 import A78150408169612 from '@/components/9781504081696-12'
 import A78150408169613 from '@/components/9781504081696-13'
 import A78150408169614 from '@/components/9781504081696-14'
 import A78150408169615 from '@/components/9781504081696-15'
 import A78150408169616 from '@/components/9781504081696-16'
 import A78150408169618 from '@/components/9781504081696-18'
 import A78150408169619 from '@/components/9781504081696-19'
 import A78150408169620 from '@/components/9781504081696-20'
 import A78150408169621 from '@/components/9781504081696-21'
 import A78150408169622 from '@/components/9781504081696-22'
 import A78150408169623 from '@/components/9781504081696-23'
 import A78150408169624 from '@/components/9781504081696-24'
 import A78150408169627 from '@/components/9781504081696-27'
 import A78150408169628 from '@/components/9781504081696-28'
 import A78150408169629 from '@/components/9781504081696-29'
 import A78150408169630 from '@/components/9781504081696-30'
 import A78150408169631 from '@/components/9781504081696-31'
 import A78150408169632 from '@/components/9781504081696-32'
 import A78150408169635 from '@/components/9781504081696-35'
 import A78150408169636 from '@/components/9781504081696-36'
 import A78150408169637 from '@/components/9781504081696-37'
 import A78150408169638 from '@/components/9781504081696-38'
 import A78150408169639 from '@/components/9781504081696-39'
 import A78150408169640 from '@/components/9781504081696-40'
 import A78150408169641 from '@/components/9781504081696-41'
 import A78150408169644 from '@/components/9781504081696-44'
 import A78150408169645 from '@/components/9781504081696-45'
 import A78150408169646 from '@/components/9781504081696-46'
 import A78150408169647 from '@/components/9781504081696-47'
 import A78150408169648 from '@/components/9781504081696-48'
 import A78150408169649 from '@/components/9781504081696-49'
 import A78150408169650 from '@/components/9781504081696-50'
 import A78150408169651 from '@/components/9781504081696-51'
 import A78150408169652 from '@/components/9781504081696-52'
 import A78150408169654 from '@/components/9781504081696-54'
 import A78150408169655 from '@/components/9781504081696-55'
 import A78150408169656 from '@/components/9781504081696-56'
 import LOVE2 from '@/components/love2'
 import A78150408169657 from '@/components/9781504081696-57'
 import A78150408169658 from '@/components/9781504081696-58'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/EBB",
 			"name" : "EBB",
 			"component" : EBB
 		},
 		{
 			"path" : "/TLU",
 			"name" : "TLU",
 			"component" : TLU
 		},
 		{
 			"path" : "/MM",
 			"name" : "MM",
 			"component" : MM
 		},
 		{
 			"path" : "/love1",
 			"name" : "love1",
 			"component" : LOVE1
 		},
 		{
 			"path" : "/Titlepage",
 			"name" : "Titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/ded",
 			"name" : "ded",
 			"component" : DED
 		},
 		{
 			"path" : "/epigraph",
 			"name" : "epigraph",
 			"component" : EPIGRAPH
 		},
 		{
 			"path" : "/9781504081696-1",
 			"name" : "9781504081696-1",
 			"component" : A7815040816961
 		},
 		{
 			"path" : "/9781504081696-2",
 			"name" : "9781504081696-2",
 			"component" : A7815040816962
 		},
 		{
 			"path" : "/9781504081696-3",
 			"name" : "9781504081696-3",
 			"component" : A7815040816963
 		},
 		{
 			"path" : "/9781504081696-5",
 			"name" : "9781504081696-5",
 			"component" : A7815040816965
 		},
 		{
 			"path" : "/9781504081696-6",
 			"name" : "9781504081696-6",
 			"component" : A7815040816966
 		},
 		{
 			"path" : "/9781504081696-7",
 			"name" : "9781504081696-7",
 			"component" : A7815040816967
 		},
 		{
 			"path" : "/9781504081696-8",
 			"name" : "9781504081696-8",
 			"component" : A7815040816968
 		},
 		{
 			"path" : "/9781504081696-10",
 			"name" : "9781504081696-10",
 			"component" : A78150408169610
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js